<template>
  <AccountLayout active-menu="inquiries">
    <div class="inquiries-page">
      <h1>My Inquiries</h1>
      <table class="simple-table" v-loading="loading">
        <thead>
          <tr>
            <th>VIN or Frame No</th>
            <th>Required parts</th>
            <th>Car details</th>
            <th>Price</th>
            <th>Reply</th>
            <th>Status</th>
            <th>Submit Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in inquiries" :key="index">
            <td>{{ item.vin_or_frame || '-' }}</td>
            <td>{{ item.required_parts || '-' }}</td>
            <td>{{ item.car_details || '-' }}</td>
            <td>{{ item.quoted_price || '-' }}</td>
            <td>{{ item.reply || '-' }}</td>
            <td>{{ item.status || '-' }}</td>
            <td>{{ formatDate(item.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </AccountLayout>
</template>

<script>
import AccountLayout from '@/components/common/AccountLayout.vue'
import { getToken } from '@/util/token-util.js'

export default {
  name: 'MyInquiriesPage',
  components: {
    AccountLayout
  },
  data() {
    return {
      inquiries: [],
      loading: false
    }
  },
  mounted() {
    if (!getToken()) {
      this.$message.error('Please log in first')
      this.$router.push({ name: 'home' })
      return
    }
    this.loadInquiries()
  },
  methods: {
    async loadInquiries() {
      this.loading = true
      try {
        const res = await this.$api({
          url: 'Inquiry/myList',
          method: 'get'
        })
        this.inquiries = res.data.items || []
      } catch (e) {
        this.$message.error('Failed to load inquiries')
      } finally {
        this.loading = false
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return String(dateStr).split('T')[0].split(' ')[0]
    },
  }
}
</script>

<style scoped>
.inquiries-page h1 {
  margin: 0 0 28px;
  color: #111;
  font-size: 28px;
  font-weight: 400;
}

.simple-table {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  color: #111;
  font-size: 18px;
}

.simple-table th {
  height: 48px;
  background: #fafafa;
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 25px;
  white-space: nowrap;
  text-align: left;
}

.simple-table td,
.simple-table th {
  padding: 0 20px;
  border-bottom: 1px solid #ddd;
}

.simple-table tr:last-child td {
  border-bottom: 0;
}

.simple-table td {
  height: 82px;
  font-family: inherit;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
}
</style>
